import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ImageCroppedEvent,
  ImageCropperComponent,
  ImageTransform,
} from 'ngx-image-cropper';
import { MaterialModule } from 'src/app/core/material.module';

@Component({
  selector: 'app-image-cropper-dialog',
  templateUrl: './image-cropper-dialog.component.html',
  styleUrl: 'image-cropper-dialog.component.scss',
  imports: [ImageCropperComponent, CommonModule, MaterialModule],
})
export class ImageCropperDialogComponent {
  previewImage: string | null = null;
  croppedBlob: Blob | null = null;
  transform: ImageTransform = {
    translateUnit: 'px',
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
    translateV: 0,
  };

  constructor(
    public dialogRef: MatDialogRef<ImageCropperDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {aspectRatio: number, resizeToWidth: number, imageChangedEvent?: Event} = {aspectRatio: 900 / 90, resizeToWidth: 900, }
  ) {}

  imageCropped(event: ImageCroppedEvent) {
    this.previewImage = event.base64 ?? null;
    this.croppedBlob = event.blob ?? null;
  }

  cancel() {
    this.dialogRef.close(null);
  }

  save() {
    if (this.croppedBlob) {
      // Convert the blob to a File for upload
      const file = new File([this.croppedBlob], 'cropped-image.png', {
        type: 'image/png',
      });
      this.dialogRef.close(file);
    } else {
      this.dialogRef.close(null);
    }
  }

  zoomOut() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! - 0.01,
    };
  }

  zoomIn() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! + 0.01,
    };
  }

  moveLeft() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! - 1,
    };
  }

  moveRight() {
    this.transform = {
      ...this.transform,
      translateH: this.transform.translateH! + 1,
    };
  }

  moveDown() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! + 1,
    };
  }

  moveUp() {
    this.transform = {
      ...this.transform,
      translateV: this.transform.translateV! - 1,
    };
  }
}
